import React from "react";

import '../styles/Card.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import {faGlobe} from '@fortawesome/free-solid-svg-icons'


class Card extends React.Component{
    render(){
        const {title, desc, github, web} = this.props;
        return(
            
            <div className="card-div">
                <div className="card-title-div">
                    <h1>{title}</h1>
                </div>
                <div className="project-desc">
                    <p>
                        {desc}
                    </p>
                </div>
                <div className="project-icons">
                    <a className="animate-grow font_sec_color" href={github} target="_blank">
                        <FontAwesomeIcon className="icons" icon={faGithub} />
                    </a>
                    <a className="animate-grow font_sec_color" href={web} target="_blank">
                        <FontAwesomeIcon className="icons" icon={faGlobe} />
                    </a>
                </div>
                </div>
        );
    }
}

export default Card;